import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const profileInfoPageK = {
  completeYourProfile: "profile_info_page.completeYourProfile",
  completeYourProfileHint: "profile_info_page.completeYourProfileHint",
  completeCreation: "profile_info_page.completeCreation",
};

export const useProfileInfoPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      completeYourProfile: t(profileInfoPageK.completeYourProfile),
      completeYourProfileHint: t(profileInfoPageK.completeYourProfileHint),
      completeCreation: t(profileInfoPageK.completeCreation),
    }),
    [i18n.language]
  );
};